import queryString from 'query-string'
import axios from 'axios'
import config from '../../../config/environment'
import store from '../../index'
import { INIT } from './orderScreenReducer'
import { modalErrorAction } from '../MobileExchanger/action'

const { dispatch } = store

export default async function mobileExchangerOrderScreen() {
            const url = window.location.href;
            const urlParamsString = url.slice((url.indexOf('?')) + 1);
            const urlParamsObj = queryString.parse(urlParamsString);
            // const orderInfo = (await axios.get(config.backendUrl + '/order/order-info?orderId=' + urlParamsObj.orderId)).data;
            // setState({orderInfo});


            setTimeout(async function getOrderInfo() {
                try {
                    const mobileOrderInfo = (await axios.get(config.backendUrl + '/order/order-info?orderHash=' + urlParamsObj.orderHash)).data;
                    dispatch({
                        type: INIT,
                        mobileOrderInfo
                    })

                    // setState({...state, orderInfo: orderInfo});

                    setTimeout(getOrderInfo, 15000); // 15 sec
                } catch (error) {
                    // console.log(error);
                    dispatch(modalErrorAction(false))
                    setTimeout(getOrderInfo, 5000); // 5 sec
                }
            }, 0); // 0 sec
        };